export const CONNECT = 'CONNECT';

export function changeConnect(bool){
    return {type: CONNECT, payload: bool};
}